import React, { useEffect, useState } from 'react';
import { MCButton, TabMenu, View } from '../basic';
import { lang, remCss } from 'src/helpers';
import moment from 'moment';
import { rangeTimeOfGroup } from './utils';
import mainModel, { models, STEPS } from './model';
import { BASE_ICONS } from 'components/svg';
import { AddSlotPanel } from 'components/slotSchedule/EditSlot';
import { SlotList } from 'components/slotSchedule/SlotList';
import { CarrouselDaysOfMonth } from 'components/complex/CarrouselDaysOfMonth';

const model = models[STEPS.SLOTS_OF_RANGE];

const tabs = [
  {
    id: 'free',
    name: lang.t('Free Slots')
  },
  {
    id: 'booked',
    name: lang.t('Appointments')
  },
  {
    id: 'all',
    name: lang.t('All')
  }
];

export const SlotsOfRange = ({ onHide, onPrev }) => {
  const { startDate, endDate, tab, title, item, parent } = model.state;
  const doctorId = mainModel.state.doctorId;
  model.use();

  const range = rangeTimeOfGroup(item, parent);

  const [openAdd, setOpenAdd] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    const { item, parent } = model.state;
    const range = rangeTimeOfGroup(item, parent);
    if (!selectedDay) {
      model.setState({ ...range });
    } else {
      const d = moment(selectedDay);
      model.setState({ startDate: d.startOf('day').valueOf(), endDate: d.endOf('day').valueOf() });
    }
  }, [selectedDay]);

  return (
    <>
      <div className='mc-flex-20 mc-modal-header' style={{ position: 'relative' }}>
        {onPrev && (
          <MCButton
            width={40}
            iconname={BASE_ICONS.BACK_ARROW}
            primary
            onClick={onPrev}
            style={{ marginVertical: -10 }}
          />
        )}
        <div className='mc-popup-title mc-grow'>{title}</div>
        <AddSlotPanel
          openAdd={openAdd}
          setOpenAdd={setOpenAdd}
          slots={slots}
          day={selectedDay || range.startDate}
          showDate={true}
          doctorId={doctorId}
          onSaved={(err, data) => {
            if (data?.ok) {
              setOpenAdd(false);
              setSelectedDay((v) => {
                model.setState({ tab: 'all' });
                if (
                  (v && moment(v).isSame(data.data.startDate, 'day')) ||
                  moment(model.state.startDate).isSame(model.state.endDate, 'day')
                ) {
                  model.emit(`slot_schedule_slot_list_all_item`, { slot: data.data, isNew: true });
                  model.emit(`slot_generate_slot_list_free_item`, { slot: data.data, isNew: true });
                } else {
                  setTimeout(() => {
                    model.emit(`slot_generate_slot_list_scroll_item`, {
                      slot: data.data
                    });
                  }, 1000);
                  return data.data.startDate;
                }
                return v;
              });
            }
          }}
        />
      </div>
      <div className='mc-modal-body mc-flex-0-col' style={{ flex: 1, paddingTop: 0 }}>
        <CarrouselDaysOfMonth
          style={{ marginTop: remCss(30) }}
          all={true}
          selectedDay={selectedDay}
          handleChangeSelectedDay={setSelectedDay}
          {...range}
        />
        <View
          style={{
            marginBottom: remCss(-60),
            height: remCss(66),
            paddingBottom: remCss(10),
            justifyContent: 'flex-end',
            zIndex: 2
          }}
        >
          <TabMenu
            tabs={tabs}
            tab={{ id: tab }}
            setTab={(tab) => {
              model.setState({ tab: tab.id });
            }}
            type={'panner'}
          />
        </View>
        {tabs.map((item) => (
          <View
            key={item.id}
            id={item.id}
            style={{
              display: tab === item.id ? 'flex' : 'none',
              flex: 1,
              marginRight: remCss(-10)
            }}
          >
            <SlotList
              tab={item.id}
              onSlots={(v) => item.id === 'all' && setSlots(v)}
              startDate={startDate}
              endDate={endDate}
              doctorId={doctorId}
              onHide={onHide}
              onBooked={() => {
                model.setState({ tab: 'booked' });
              }}
            />
          </View>
        ))}
      </div>
    </>
  );
};
